import { gql } from '@apollo/client';

export * from './contactUpdate.mutation.generated';

export const CONTACT_UPDATE = gql`
  mutation contactUpdate($contactId: ID!, $contactParams: ContactUpdateParams!) {
    contactUpdate(input: { contactId: $contactId, contactParams: $contactParams }) {
      success
      errors
      contact {
        ...ContactFragment
        escrow {
          id
          depositorConfigured
          beneficiaryConfigured
          agreement {
            policy {
              generate
            }
          }
        }
      }
    }
  }
`;
